import React from 'react';
import { useHistory, getLocale } from 'umi';
import NoDataCommon from '../NoDataCommon';
import {
  getCacheExpiredText, 
  TCacheExpiredScene,
} from '@op/constants/cacheExpired';

type TCacheExpiredTipsProps = {
  /** 缓存失效场景（下钻 / 下载） */
  scene: TCacheExpiredScene;
  /** 空态高度 */
  height?: number | string;
};

/**
 * 缓存失效统一兜底提示
 * 用于下钻/下载目标页读取不到参数（服务端缓存被后端清理、本地缓存过期等）时展示，
 * 提供「返回首页」按钮统一跳转到 /opinion，避免白屏 / 空数据 / 卡 loading。
 */
export default function CacheExpiredTips({
  scene,
  height = 760,
}: TCacheExpiredTipsProps) {
  const history = useHistory();
  const isEn = getLocale() === 'en-US';
  const desc = getCacheExpiredText(scene, isEn);

  return (
    <NoDataCommon hasImg hasDesc emptyDescText={desc} style={{ height }} />
  );
}
